import { React, useEffect } from 'react';
import Nav from './nav';
import Tab from './tabs';

function AdminUNIM() {
  return (
    <div className="admin-page">
        <body>
            <Tab/>
      </body>
      {/* <footer> EDAP-UNILIS © All Rights Reserved.</footer> */}
    </div>
  );
}

export default AdminUNIM;
